export const buttons = {
    featuredProjects: {
        fontFamily: "Stolzl",
        fontWeight: "500",
        position: "relative",
    },
}
